var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("RecipientMenu", {
        ref: "recipientMenu",
        attrs: { position: _vm.menuPosition, configuration: _vm.configuration },
      }),
      _vm._v(" "),
      _c("ReportsMenu", {
        ref: "reportsMenu",
        attrs: { position: _vm.menuPosition, configuration: _vm.configuration },
      }),
      _vm._v(" "),
      _c("ConfirmationMenu", {
        ref: "confirmationMenu",
        attrs: { position: _vm.menuPosition },
      }),
      _vm._v(" "),
      _c(
        "v-card-title",
        { staticClass: "headline pb-0" },
        [
          _vm._v("\n    Recipients\n    "),
          _c("span", { staticClass: "font-weight-light body-2" }, [
            _vm._v(
              "\n       \n      ⋅\n      " +
                _vm._s(_vm.configuration.recipients.length) +
                "\n      " +
                _vm._s(
                  _vm.pluralize(
                    "recipient",
                    _vm.configuration.recipients.length
                  )
                )
            ),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "rounded font-weight-regular emphasize-clear",
            attrs: {
              "prepend-inner-icon": "search",
              "hide-details": "",
              clearable: "",
              solo: "",
              placeholder: "Search recipients",
            },
            on: {
              "click:clear": function ($event) {
                _vm.search = ""
              },
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            {
              ref: "addItem",
              attrs: { outline: "", small: "", color: "success" },
              on: {
                click: function ($event) {
                  return _vm.addItem()
                },
              },
            },
            [
              _c("v-icon", [_vm._v("add")]),
              _vm._v(" "),
              _c("span", { staticClass: "text-" }, [
                _vm._v(_vm._s(_vm.$t("Button.AddRecipient"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          pagination: _vm.pagination,
          headers: _vm.headers,
          search: _vm.search,
          items: _vm.items,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item, index }) {
              return [
                _c("td", { staticClass: "text-xs-left break-all" }, [
                  _vm._v(_vm._s(item.email)),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left break-all" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left break-all" }, [
                  item.reports.length == 0
                    ? _c("div", [_vm._v("\n          All reports\n        ")])
                    : _c(
                        "div",
                        [
                          _vm._l(
                            item.reports.slice(0, 10),
                            function (report, reportIndex) {
                              return _c(
                                "v-chip",
                                {
                                  key: `report-${index}-${reportIndex}`,
                                  attrs: { small: "" },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(report.name) +
                                      "\n          "
                                  ),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          item.reports.length > 10
                            ? _c("v-chip", { attrs: { small: "" } }, [
                                _vm._v(
                                  "\n            + " +
                                    _vm._s(item.reports.length - 10) +
                                    " others\n          "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "mx-0",
                        attrs: { color: "info", outline: "", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.editReports(item)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "text-none" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("Button.CustomizeReportsReceived")
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ml-0",
                        attrs: { icon: "", flat: "", color: "info", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.editItem(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("edit")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-0",
                        attrs: {
                          icon: "",
                          flat: "",
                          color: "error",
                          small: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("clear")])],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }